import React, { useContext, useEffect, useState,useRef } from "react";
import { observer } from "mobx-react";
import Form from 'react-bootstrap/Form';
import Skeleton from 'react-loading-skeleton'
import { useTranslation, Trans } from "react-i18next";
import moment from 'moment';
import { getFirstOfMonth, getLastMonth } from "../../utils";

//import 'moment/locale/fr';
/*import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";*/

//import DateTimeField from "react-bootstrap-datetimepicker"


const FormDate = (props) => {
    const { t, i18n } = useTranslation();
    const [value, setValue] = useState("");
    const inputRef = useRef(null);

    useEffect(() => {
        var val = (props.object ? (props.object)?.[props.id] : props.value) || "";       
        setValue(val);
    }, [props.object]);

    const formatValue = () => {        
        return moment(value, "YYYY-MM-DD")?.isValid() ? moment(value, "YYYY-MM-DD").format(props.month ? "MM.yyyy" : "DD.MM.yyyy") : "";
    }

    return (
        <Form.Group controlId={props.id}>
            {props.isLoading ? <Skeleton /> : <Form.Label>{props.label}</Form.Label>}
            {props.isLoading ?
                <Skeleton height={30} /> :
                <Form.Control autoComplete="off" /*placeholder={t("enterDate")}*/ required={props.required} value={formatValue()} onChange={() => { }} onClick={() => inputRef?.current?.showPicker()} />


            }
            <Form.Control                    
                    style={{ height: 0, padding:0,margin:0,border:0}}                    
                    ref={inputRef}
                    required={props.required}
                    disabled={props.disabled}
                    name={props.id}
                    type={props.month ? "month" : "date"}
                    placeholder={props.placeholder ? props.placeholder : t("enterValue")}
                    value={value} onChange={(e) => { setValue(e.target.value) }} ></Form.Control>   
            
            <Form.Control.Feedback type="invalid">
                {t('fieldRequired')}
            </Form.Control.Feedback>
        </Form.Group>
    );
};

export default observer(FormDate);
